<app-action-modal
  #actionModal
  [disabled]="submitted"
  [submitDisabled]="submitDisabled"
  [showHeader]="true"
  submitButtonClass="lty-btn-primary"
  [size]="isPlatformSend ? 'lg' : 'sm'"
  headerIconState="success"
  customModalClass="cancellation-send-modal"
  (submitted)="confirm()"
  (closed)="onClosed()"
>
  <div class="d-flex" headerIcon>
    <app-send-icon height="20px" width="20px" color="var(--success-500)" />
  </div>
  <span class="cancellation-send-modal__title" mainTitle i18n
    >Envoyer la lettre de résiliation</span
  >
  <form body class="lty-form cancellation-send-modal__form" [formGroup]="form">
    <div class="cancellation-send-modal__options">
      <div>
        <label class="cancellation-send-modal__option">
          <input
            type="radio"
            class="cancellation-send-modal__radio"
            formControlName="mode"
            value="EMAIL"
            [attr.disabled]="insurerEmail ? null : ''"
          />
          <span i18n>Envoyer à l'assureur à travers la plateforme</span>
        </label>
        @if (!insurerEmail) {
          <small class="cancellation-send-modal__hint" i18n>
            Aucune adresse de résiliation dans le catalogue de l'assureur
          </small>
        }
      </div>
      <label class="cancellation-send-modal__option">
        <input
          type="radio"
          class="cancellation-send-modal__radio"
          formControlName="mode"
          value="MARK"
        />
        <span i18n>Marquer comme envoyé</span>
      </label>
    </div>

    @if (isPlatformSend) {
      <div class="form-group mb-16">
        <label for="cancellation-send-recipient" i18n>Destinataire</label>
        <input
          class="form-control"
          type="text"
          id="cancellation-send-recipient"
          [value]="insurerEmail"
          readonly
        />
      </div>
      <div class="form-group mb-16">
        <label for="cancellation-send-subject" i18n>Objet</label>
        <input
          class="form-control"
          type="text"
          id="cancellation-send-subject"
          formControlName="subject"
          [placeholder]="renderLoading ? loadingText : ''"
        />
      </div>
      <!-- `modalOpen` is a TinyMCE lifecycle gate; see `ComposeModalBase`. -->
      @if (modalOpen) {
        <div class="form-group mb-16">
          <label i18n>Corps du mail</label>
          <editor
            formControlName="body"
            [plugins]="editorPlugins"
            [toolbar]="editorToolbar"
          />
        </div>
      }
    }
  </form>
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
